// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bcp_a bhh_cw bhh_jx bhh_jo bhh_rh bhh_vf"};